import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DashboardLayout } from '../../Layout/DashboardLayout'
import CustomTable from '../../Components/CustomTable'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faSearch } from '@fortawesome/free-solid-svg-icons'
import BASEURL from '../../Config/global';
import axios from 'axios';
import CustomPagination from '../../Components/CustomPagination'
import CustomFilters from '../../Components/CustomFilters'
import { disabledButtonByPermission } from '../../Components/Permissions'
import { PermissionsContext } from '../../Layout/PermissionContext'

const FeaturedMix = () => {
  const { permissions } = useContext(PermissionsContext)
  const navigate = useNavigate()
    const [config, setConfig] = useState({ error: false, msg: '', value: '', loader: false });
    const [soundMixList, setSoundMixList] = useState([]);
    const [enteries, setEnteries] = useState(10);
    const [offset, setOffset] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedLanguage, setSelectedLanguage] = useState("english");

    useEffect(() => {
        getFeaturedListByEmail()
    }, [enteries, offset, selectedLanguage])

    const modulesWisePermission = (condition) =>{
        if(!permissions){
          return 'd-none'
        }
        return disabledButtonByPermission(permissions, condition)
      }
    const header = [
        {
            key: "ids",
            title: "Publish",
        },
        {
            key: "mixid",
            title: "Mix ID",
        },
        {
            key: "title",
            title: "Title",
        },
        {
            key: "underagecontent",
            title: "Under age content",
        },
        {
            key: "actions",
            title: "Action",
        },
    ];



    const getFeaturedListByEmail = async () => {
        // fetch data from API with email
        // update state with fetched data
        try {
            if (config?.value === "" || config?.value === null) {
                return
            }
            setConfig({ ...config, loader: true, error: false });
            const languageParam = selectedLanguage === "spanish" ? "&language=spanish" : "";
            const response = await axios.get(`${BASEURL}/api/sounds/user_mix?limit=${enteries}&offset=${offset}&search=${config?.value}${languageParam}`);
            setConfig({ ...config, loader: false });
            if (response.data.count === 0 && response.data.data.length === 0) {
                setSoundMixList([])
                setConfig({ ...config, error: true, msg: "No Record Found" });
                setTotalCount(0);
            } else {
                setSoundMixList(response?.data?.data)
                setTotalCount(response?.data?.count);
            }
        } catch (error) {
            setSoundMixList([])
            setConfig({ ...config, error: true, msg: "No Record Found", loader: false });
        }
    }

    // Navigate to edit route with language query parameter
    const handleEdit = (mixer_id) => {
        navigate(`/featured-mix/edit/${mixer_id}?language=${selectedLanguage}`)
    }
    const handleChangeEntries = (no) => {
        setOffset(0)
        setEnteries(no)
    }

    return (
        <>

            <DashboardLayout>
                <div className='container-fluid'>
                    {/* TOP ROW / SEARCH BAR */}
                    <div className="row mb-3">
                        <div className="col-8">
                            <h2 className="mainTitle">Featured Mixes</h2>
                        </div>
                        <div className="col-4 text-end">
                            {/* <button type="button"
                                disabled={updatedFeatureMix.length > 0 ? false : true}
                                className={`customButton ${soundMixList.length > 0 ? 'primaryButton' : ''}`}
                                onClick={updateMixSortingPositionConfirmation}>
                                Update Mix
                            </button> */}
                        </div>
                        <div className="row mb-3">
                            <div className="col-6">
                                <CustomFilters
                                    enteries={enteries}
                                    totalCount={totalCount}
                                    entriesFilter={true}
                                    setEnteries={handleChangeEntries}
                                    // languageFilter
                                    // languageValue={selectedLanguage}
                                    // setLanguageValue={setSelectedLanguage}
                                />
                            </div>
                            <div className="col-6 my-2 text-end">
                                <form autoComplete="off" onSubmit={(event) => {
                                    event.preventDefault()
                                    getFeaturedListByEmail()
                                }} className="searchWrapper w-100" style={{ maxWidth: '500px' }}>
                                    <input
                                        type="text"
                                        placeholder="Please enter user email"
                                        name="search"
                                        className="filterInput searchInput w-100"
                                        autoComplete='off'
                                        value={config?.value}
                                        onChange={(event) => {
                                            setConfig({ ...config, value: event.target.value?.trim() });
                                        }}
                                    />
                                    <button type='submit' className="searchButton notButton">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <CustomTable headers={header}>
                        <tbody>
                            {(!config.loader && soundMixList.length > 0) ? (
                                soundMixList?.map((item, index) => (
                                    <tr key={item.id}>
                                        <td width={150}>
                                            <div className='mt-2'>
                                                <input
                                                    type="checkbox"
                                                    name="featured"
                                                    key={`featured-${index}`}
                                                    checked={item.featured_mix_status ? true : false}
                                                // onChange={() => {
                                                //     let temp = [...soundMixList]
                                                //     temp[index] = { ...temp[index], featured_mix_status: !item.featured_mix_status }
                                                //     setSoundMixList(temp);
                                                //     let tempUpdatedFeaturMixes = [...updatedFeatureMix]
                                                //     let findIndex = tempUpdatedFeaturMixes.findIndex(f => f.id === item.id)
                                                //     if (findIndex !== -1) {
                                                //         tempUpdatedFeaturMixes[findIndex] = { id: item.id, featured_mix_status: !item.featured_mix_status }
                                                //     } else {
                                                //         tempUpdatedFeaturMixes.push({ id: item.id, featured_mix_status: !item.featured_mix_status })
                                                //     }
                                                //     setUpdatedFeatureMix(tempUpdatedFeaturMixes)
                                                // }}
                                                />
                                            </div>

                                        </td>
                                        <td>{item.id}</td>
                                        <td>{item.name}</td>
                                        <td>{item.child_content ? "YES" : "NO"}</td>
                                        <td>{<FontAwesomeIcon
                                            className={`${modulesWisePermission('can_edit')}`}
                                            icon={faEdit}
                                            onClick={() => handleEdit(item.id)}
                                            style={{ cursor: 'pointer' }} />
                                        }</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    {config.error && <td colSpan="3" className="text-center">{config.msg}</td>}
                                    {config.loader && <td colSpan="3" className="text-center"> <div className="spinner-border" role="status"></div></td>}
                                </tr>
                            )}
                        </tbody>
                    </CustomTable>
                    <div className="row mb-3">
                        <div className="col-12">
                            <CustomPagination
                                enteries={enteries}
                                totalCount={totalCount}
                                setCurrentPage={setOffset}
                                currentPage={offset}
                            />
                        </div>
                    </div>

                </div>
            </DashboardLayout>
        </>
    )
}

export default FeaturedMix